import React, { ForwardedRef, forwardRef, PropsWithChildren } from 'react';
import { StackContainer, DirectionType } from './Stack.styles';
import { ColumnProps } from '../Column.styles';
import { SpacingProps } from '../Spacing.styles';
import { componentPropsToStyledProps } from 'src/app/styles/helper';
import { MaxWidthProps } from '../MaxWidth.styles';
import { VisibilityProps } from '../Visibility.styles';
import { ColorModePropKeys, DataColorMode } from 'src/app/styles/colors';
import { BorderProps } from '../Border.styles';

export interface StackProps
  extends PropsWithChildren,
    ColumnProps,
    SpacingProps,
    MaxWidthProps,
    VisibilityProps,
    BorderProps {
  direction?: DirectionType;
  directionSm?: DirectionType;
  directionMd?: DirectionType;
  directionLg?: DirectionType;
  directionXl?: DirectionType;
  direction2xl?: DirectionType;
  align?: 'flex-start' | 'flex-end' | 'center' | 'stretch';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around';
  id?: string;
  className?: string;
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  background?: ColorModePropKeys;
  flexWrap?: 'wrap' | 'nowrap';
  dataColorMode?: DataColorMode;
  dataCy?: string;
}

const Stack = (
  { children, className, id, dataColorMode, dataCy, ...props }: StackProps,
  forwardedRef: ForwardedRef<HTMLDivElement>
): JSX.Element => {
  return (
    <StackContainer
      id={id}
      className={className}
      ref={forwardedRef}
      data-color-mode={dataColorMode}
      data-cy={dataCy}
      {...componentPropsToStyledProps(props)}
    >
      {children}
    </StackContainer>
  );
};

export default forwardRef(Stack);
